import EsmdCaseTab from "./component";

export default EsmdCaseTab;